var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "yxt-row",
        { staticClass: "bg-white" },
        [
          _c(
            "yxt-col",
            [
              _c(
                "yxt-form",
                {
                  ref: "ruleForm",
                  attrs: {
                    model: _vm.ruleForm,
                    rules: _vm.rules,
                    "label-width": "100px",
                  },
                },
                [
                  _c(
                    "yxt-form-item",
                    {
                      attrs: {
                        label: _vm.$t("pc_biz_ote_lbl_examname"),
                        prop: "name",
                      },
                    },
                    [
                      _c("yxt-input", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          placeholder: _vm.$t("pc_biz_ote_tip_examnametip"),
                          disabled: _vm.status !== 0,
                          "show-word-limit": "",
                          maxlength: 200,
                        },
                        model: {
                          value: _vm.ruleForm.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "name", $$v)
                          },
                          expression: "ruleForm.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "yxt-form-item",
                    {
                      staticClass: "color-gray-9",
                      attrs: { label: _vm.$t("pc_biz_ote_lbl_entertime") },
                    },
                    [
                      _c(
                        "yxt-checkbox",
                        {
                          model: {
                            value: _vm.isEntryTimeCtrl,
                            callback: function ($$v) {
                              _vm.isEntryTimeCtrl = $$v
                            },
                            expression: "isEntryTimeCtrl",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("pc_biz_ote_lbl_entertimelimit"))
                          ),
                        ]
                      ),
                      _vm.isEntryTimeCtrl
                        ? _c(
                            "span",
                            { staticClass: "ml10" },
                            [
                              _c("yxt-date-picker", {
                                staticStyle: { width: "440px" },
                                attrs: {
                                  type: "datetimerange",
                                  "range-separator":
                                    _vm.$t("pc_biz_ote_lbl_to"),
                                  "start-placeholder": _vm.$t(
                                    "pc_biz_ote_lbl_starttime"
                                  ),
                                  "end-placeholder": _vm.$t(
                                    "pc_biz_ote_lbl_endtime"
                                  ),
                                  format: "yyyy-MM-dd HH:mm",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                },
                                model: {
                                  value: _vm.entryTime,
                                  callback: function ($$v) {
                                    _vm.entryTime = $$v
                                  },
                                  expression: "entryTime",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "yxt-form-item",
                    {
                      attrs: {
                        label: _vm.$t("pc_biz_ote_lbl_exampaper"),
                        prop: "examName",
                      },
                    },
                    [
                      _c(
                        "yxt-button",
                        {
                          attrs: {
                            type: "primary",
                            disabled: _vm.status !== 0,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.openSelectExamDrawer()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("pc_biz_ote_btn_selectpaper")))]
                      ),
                      _vm.ruleForm.examName
                        ? _c("span", { staticClass: "color-gray-6 ml10" }, [
                            _vm._v(
                              _vm._s(_vm.ruleForm.examName) +
                                "，" +
                                _vm._s(
                                  _vm.$t("pc_biz_ote_lbl_totalscore", [
                                    _vm.ruleForm.totalScore,
                                  ])
                                )
                            ),
                            _vm.status === 0
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "hand ml5 color-gray-6",
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteExam()
                                      },
                                    },
                                  },
                                  [
                                    _c("yxt-svg", {
                                      staticClass:
                                        "hover-primary-6 hand yxtbiz-exam-arrange__tip-icon-t3",
                                      attrs: {
                                        width: "16px",
                                        height: "16px",
                                        "icon-class": "close",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "yxt-form-item",
                    {
                      attrs: {
                        label: _vm.$t("pc_biz_ote_lbl_passscore"),
                        prop: "passScore",
                      },
                    },
                    [
                      _c("yxt-input", {
                        directives: [
                          { name: "enter-float", rawName: "v-enter-float" },
                        ],
                        staticStyle: { width: "96px" },
                        attrs: {
                          autocomplete: "off",
                          placeholder: _vm.$t("pc_biz_ote_tip_scoreinputtip"),
                          disabled: _vm.status !== 0,
                          maxlength: 3,
                        },
                        model: {
                          value: _vm.ruleForm.passScore,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "passScore", $$v)
                          },
                          expression: "ruleForm.passScore",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "yxt-form-item",
                    {
                      attrs: {
                        label: _vm.$t("pc_biz_ote_lbl_goodscore"),
                        prop: "excellenceScore",
                      },
                    },
                    [
                      _c("yxt-input", {
                        directives: [
                          { name: "enter-float", rawName: "v-enter-float" },
                        ],
                        staticStyle: { width: "96px" },
                        attrs: {
                          autocomplete: "off",
                          placeholder: _vm.$t("pc_biz_ote_tip_scoreinputtip"),
                          disabled: _vm.status !== 0,
                          maxlength: 3,
                        },
                        model: {
                          value: _vm.ruleForm.excellenceScore,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "excellenceScore", $$v)
                          },
                          expression: "ruleForm.excellenceScore",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.reward || _vm.masterType !== 3
                    ? _c(
                        "yxt-form-item",
                        {
                          attrs: {
                            label: _vm.$t("pc_biz_ote_lbl_rewardsetting"),
                          },
                        },
                        [
                          _vm.reward
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "yxt-checkbox",
                                    {
                                      attrs: { disabled: _vm.status !== 0 },
                                      model: {
                                        value: _vm.ruleForm.isPassedCredit,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.ruleForm,
                                            "isPassedCredit",
                                            $$v
                                          )
                                        },
                                        expression: "ruleForm.isPassedCredit",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "pc_biz_ote_lbl_passtogetstudyscore"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm.ruleForm.isPassedCredit
                                    ? _c("yxt-input", {
                                        directives: [
                                          {
                                            name: "enter-float",
                                            rawName: "v-enter-float",
                                          },
                                        ],
                                        staticClass: "mh8",
                                        staticStyle: { width: "96px" },
                                        attrs: {
                                          maxlength: 5,
                                          autocomplete: "off",
                                          disabled: _vm.status !== 0,
                                        },
                                        model: {
                                          value: _vm.ruleForm.passedCredit,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.ruleForm,
                                              "passedCredit",
                                              $$v
                                            )
                                          },
                                          expression: "ruleForm.passedCredit",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.reward
                            ? _c(
                                "div",
                                { staticClass: "mt10" },
                                [
                                  _c(
                                    "yxt-checkbox",
                                    {
                                      attrs: { disabled: _vm.status !== 0 },
                                      model: {
                                        value: _vm.ruleForm.isPassedPoint,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.ruleForm,
                                            "isPassedPoint",
                                            $$v
                                          )
                                        },
                                        expression: "ruleForm.isPassedPoint",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "pc_biz_ote_lbl_passtogetscore"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm.ruleForm.isPassedPoint
                                    ? _c("yxt-input", {
                                        directives: [
                                          {
                                            name: "enter-number",
                                            rawName: "v-enter-number",
                                          },
                                        ],
                                        staticClass: "mh8",
                                        staticStyle: { width: "96px" },
                                        attrs: {
                                          maxlength: 5,
                                          autocomplete: "off",
                                          disabled: _vm.status !== 0,
                                        },
                                        model: {
                                          value: _vm.ruleForm.passedPoint,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.ruleForm,
                                              "passedPoint",
                                              $$v
                                            )
                                          },
                                          expression: "ruleForm.passedPoint",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.masterType !== 3 && !_vm.oteCerStatus.hidden
                            ? _c(
                                "div",
                                { class: _vm.reward ? "mt10" : "" },
                                [
                                  _c(
                                    "yxt-checkbox",
                                    {
                                      attrs: {
                                        disabled:
                                          _vm.status !== 0 ||
                                          _vm.oteCerStatus.disabled,
                                      },
                                      model: {
                                        value: _vm.isIssueCer,
                                        callback: function ($$v) {
                                          _vm.isIssueCer = $$v
                                        },
                                        expression: "isIssueCer",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.$t(
                                              "pc_biz_ote_lbl_passtogetcer"
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                      _c(
                                        "yxt-tooltip",
                                        {
                                          attrs: {
                                            effect: "dark",
                                            content: _vm.$t(
                                              "pc_biz_ote_tip_passtogetcertip"
                                            ),
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "ml8 v-mid" },
                                            [
                                              _c("yxt-svg", {
                                                staticClass:
                                                  "yxtbiz-exam-arrange__tip-icon",
                                                attrs: {
                                                  width: "16px",
                                                  height: "16px",
                                                  "icon-class": "info-cirlce-o",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm.isIssueCer
                                    ? _c(
                                        "div",
                                        { staticClass: "ml20" },
                                        [
                                          _c(
                                            "yxt-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                disabled: _vm.status !== 0,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.openSelectCerDrawer()
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "pc_biz_ote_btn_selectcer"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm.ruleForm.cerName
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "color-gray-6 mh8",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.ruleForm.cerName)
                                                  ),
                                                  _vm.status === 0
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "ml5 color-gray-6",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.deleteCer()
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("yxt-svg", {
                                                            staticClass:
                                                              "hover-primary-6 hand yxtbiz-exam-arrange__tip-icon-t3",
                                                            attrs: {
                                                              width: "16px",
                                                              height: "16px",
                                                              "icon-class":
                                                                "close",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "yxt-form-item",
                    {
                      attrs: {
                        label: _vm.$t("pc_biz_ote_lbl_examdesc"),
                        prop: "description",
                      },
                    },
                    [
                      _c("yxt-input", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "textarea",
                          placeholder: _vm.$t("pc_biz_ote_tip_examdescinput"),
                          rows: "5",
                          autocomplete: "off",
                          maxlength: 200,
                        },
                        model: {
                          value: _vm.ruleForm.description,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "description", $$v)
                          },
                          expression: "ruleForm.description",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "yxt-drawer",
        {
          ref: "selector",
          attrs: {
            title: _vm.$t("pc_biz_ote_btn_selectpaper"),
            size: "960px",
            "append-to-body": "",
            "modal-append-to-body": "",
            visible: _vm.selectExamDrawerData.isShowSelectExamDrawer,
            "destroy-on-close": true,
            direction: "rtl",
            "before-close": function () {
              _vm.saveExamSelect(true)
            },
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(
                _vm.selectExamDrawerData,
                "isShowSelectExamDrawer",
                $event
              )
            },
          },
        },
        [
          _c("yxtbiz-exam-selector", {
            attrs: {
              functionCode: _vm.functionCode,
              dataPermissionCode: _vm.dataPermissionCodes.selectExam,
              type: _vm.masterType === 1 || _vm.masterType === 3 ? 0 : 1,
            },
            on: {
              select: function ($event) {
                return _vm.saveExamSelect()
              },
            },
            model: {
              value: _vm.selectExamDrawerData.exam,
              callback: function ($$v) {
                _vm.$set(_vm.selectExamDrawerData, "exam", $$v)
              },
              expression: "selectExamDrawerData.exam",
            },
          }),
        ],
        1
      ),
      _c(
        "yxt-drawer",
        {
          attrs: {
            title: _vm.$t("pc_biz_ote_btn_selectcer"),
            visible: _vm.selectCerDrawerData.isShowSelectCerDrawer,
            size: "640px",
            direction: "rtl",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(
                _vm.selectCerDrawerData,
                "isShowSelectCerDrawer",
                $event
              )
            },
          },
        },
        [
          _c("yxtbiz-certificate-selector", {
            attrs: {
              functionCode: _vm.functionCode,
              dataPermissionCode: _vm.dataPermissionCodes.selectCer,
            },
            model: {
              value: _vm.selectCerDrawerData.cer,
              callback: function ($$v) {
                _vm.$set(_vm.selectCerDrawerData, "cer", $$v)
              },
              expression: "selectCerDrawerData.cer",
            },
          }),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "yxt-button",
                {
                  attrs: { plain: "" },
                  on: {
                    click: function ($event) {
                      return _vm.cancleCerSelect()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("pc_biz_ote_btn_cancle")))]
              ),
              _c(
                "yxt-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.saveCerSelect()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("pc_biz_ote_btn_confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }